import { Box, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import PageTitle from "../../../../Displays/PageTitle";
import { SMART_CHARGING_PATHS } from "src/consts/Routes/SmartCharging";
import { SMART_CHARGING_ROUTES } from "src/consts/Routes/SmartCharging";
import PageSubTitle from "../../../../Displays/PageSubTitle";
import VerticalLinearProgress from "../../../VerticalLinearProgressBar";

export const tariffCalculator = (pathname: string) => {
  switch (pathname) {
    case SMART_CHARGING_ROUTES.INTRO:
      return 95;
    case SMART_CHARGING_ROUTES.ONBOARDING_SLIDER:
      return 95;
    case SMART_CHARGING_ROUTES.CONNECT_CONFIRM:
      return 115;
    case SMART_CHARGING_ROUTES.CONNECTING:
      return 135;
    case SMART_CHARGING_ROUTES.CONNECTING_SUCCESS:
      return 155;
    case SMART_CHARGING_ROUTES.CONNECTING_ERROR:
      return 155;
    default:
      return 70;
  }
};

const SmartChargingOnboardingProgressBar = () => {
  const { pathname } = useLocation();

  return (
    <Stack
      gap="13px"
      sx={{
        display: { xs: "none", sm: "flex" },
      }}
    >
      <PageTitle text={"Menü"} />
      {SMART_CHARGING_PATHS.includes(pathname) && (
        <Box
          sx={{
            gap: 3,
            height: 155,
            display: { xs: "flex", sm: "default" },
          }}
        >
          <VerticalLinearProgress
            variant="determinate"
            value={155 - tariffCalculator(pathname)}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <PageSubTitle text={"Start"} />
            <PageSubTitle text={"Wallbox verbinden"} />
            <PageSubTitle text={"Einstellungen überprüfen"} />
            <PageSubTitle text={"Verbindung herstellen"} />
            <PageSubTitle text={"Status"} />
          </Box>
        </Box>
      )}
    </Stack>
  );
};

export default SmartChargingOnboardingProgressBar;
